import { IInitialState } from 'store/models';
import { authStateSelector } from './authStateSelector';

export function currentUserIdSelector(state: IInitialState) {
	return authStateSelector(state).partnerId;
}
